// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"d768068c","395":"dea3f147","659":"9de32675","899":"627845c0"}[chunkId] + ".chunk.js";
};